import { Routes, Route } from "react-router-dom";
import { PunchOutPage } from "./pages/PunchOutPage";
import { FinalisePage } from "./pages/FinalisePage";
import { DirectOrderPage } from "./pages/DirectOrderPage";
import { ReorderPage } from "./pages/ReorderPage";
import { QuotePage } from "./pages/QuotePage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { ConfirmationPage } from "./pages/ConfirmationPage";
import { ErrorPage } from "./pages/ErrorPage";
import { SalesTeamPage } from "./pages/SalesTeamPage";
import { DevLoginPage } from "./pages/DevLoginPage";
import { VersionBadge } from "./components/VersionBadge";

export function App() {
  return (
    <>
      <Routes>
        <Route path="/punchout/start" element={<PunchOutPage />} />
        <Route path="/punchout/finalise" element={<FinalisePage />} />
        <Route path="/reorder" element={<ReorderPage />} />
        <Route path="/quote" element={<QuotePage />} />
        <Route path="/salesteam" element={<SalesTeamPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/order/confirmation" element={<ConfirmationPage />} />
        <Route path="/error/:type" element={<ErrorPage />} />
        {import.meta.env.DEV && (
          <Route path="/dev/login" element={<DevLoginPage />} />
        )}
        <Route path="/" element={<DirectOrderPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
      <VersionBadge />
    </>
  );
}
